module.exports = __webpack_public_path__ + "static/media/img2-3.cabe16ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/limon/nutricheck_foliar/P/img2-3.png
// module id = 1678
// module chunks = 3